<span class="section-heading">
  <sim-icon [icon]="icon()" [sizeInPx]="20" color="var(--text-icon)" />
  <ng-content />
</span>
